import { render } from "./Domains.vue?vue&type=template&id=4b7278b6&scoped=true"
import script from "./Domains.vue?vue&type=script&lang=js"
export * from "./Domains.vue?vue&type=script&lang=js"

import "./Domains.vue?vue&type=style&index=0&id=4b7278b6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7278b6"]])

export default __exports__